import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import { Link } from '@ontruck/orc';

const DistanceCell = ({ className, handleClick, distance, distanceUnit, children }) => {
  return (
    <Link
      className={className}
      onClick={handleClick}
      text={
        (!!children && children) || (
          <Fragment>
            {distance} {''}
            {distanceUnit}
          </Fragment>
        )
      }
      weight="bold"
    />
  );
};

DistanceCell.propTypes = {
  distance: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  distanceUnit: PropTypes.string.isRequired,
  handleClick: PropTypes.func,
  className: PropTypes.string,
};

export default DistanceCell;
